<template>
<div class="text-center fs-14 pt-20 lh-1-4">
  <div class="mb-5"><strong>24/7 Internet Support: </strong> {{(phone ? phone : default_phone) | phone}}</div>
  <div><strong>My Device: </strong> <span id="my_ip">{{ip}}</span> <span> - </span> <span id="my_mac">{{mac}}</span></div>
</div>
</template>

<script>
export default {
  name: 'support_and_device_info',
  props: ['mac','ip','phone'],
  data(){
    return{
      default_phone: 8772822519,
    }
  },
  filters: {
    phone:function(value) {
      value = value.toString();
      return '(' + value.substr(0,3) + ') ' + value.substr(3,3) + '-' + value.substr(6,4);
    }
  },
}
</script>
<style>
</style>
